<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/usdy@2x.webp 2x, {CDN_URL}/ventures/usdy.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/usdy@2x.png 2x, {CDN_URL}/ventures/usdy.png 1x', type: 'image/png' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/74774851/Usdy-Brand-Identity-Design" :title="$t('cta')" class="button-link" v-html="$t('cta')")
        .u-mb-xs
        AppLink(to="https://www.behance.net/gallery/78505175/Usdy-UIUX-Design" :title="$t('cta2')" class="button-link" v-html="$t('cta2')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Usdy",
    "pageDesc":"Usdy is an elearning platform that provides consolidated learning paths in a variety of fields and connects the online learning with the offline experience.",
    "mantra":"Usdy elearning |platform.",
    "content":"<p>As students and professionals, it could be hard sometimes to get materials that are scientific and follows the standards of the field. With so many online courses that focus on selling the course not helping you build up a career, it’s hard to find an in-depth knowledge in the field. And as the topics get harder, the need for an instructor to guide you during the process becomes more essential so we came up with Usdy.</p><p>That’s why we started Usdy, our online learning platform that combines both the benefits of online learning with the offline instructing. The platform targets students of all ages and instructors from different fields. The main target behind the courses is not giving students the technical knowledge only, but also the soft skills needed to perform their tasks smoothly and achieve personal growth.</p><p>The platform aims to change the standards of learning known in communities and promote the value of continuous learning and development. Through a hard selecting process, we pick only the courses that would create a logical learning path for students and graduate a fully educated generation. The course combines different types of materials from videos, podcasts, blog posts and imagery.</p><p>The platform was designed to provide an interactive learning experience. By capitalizing on the latest methods in education, it helps students to better memorize and understand the information. And as some skills require online learning with offline training and workshops, we provide instructors with a place through which they can interact with their students.</p><p>Usdy will be launched by late 2020 but you can see the full identity and UI/UX design on Behance.</p>",
    "cta":"Brand identity",
    "cta2":"UI/UX design"
  },
  "ar": {
    "pageTitle":"يسدي",
    "pageDesc":"يسدي منصة للتعليم الإلكتروني توفر مسارات تعليمية موحدة في مجالات متنوعة تربط تجربة التعلم الأونلاين بتجربة التعلم الأوفلاين.",
    "mantra":"منصة يسدي |للتعليم الإلكتروني.",
    "content":"<p>كطلاب أو حتى محترفين قد يكون من الصعب في بعض الأحيان الحصول على مواد تعليمية حقيقة تتبع المعايير. في ظل وجود العديد من الدورات التدريبية عبر الإنترنت التي تركز على الأكثر على بيع الدورات التدريبية وبهذا لا تساعد في بناء مهنة. وبهذا لا تستطيع العثور على معرفة متعمقة في المجال. وبما أن الموضوعات تزداد صعوبة يومًا بعد يوم، فإن الحاجة إلى مدرب لارشادك أثناء عملية التعلم أصبح أكثر أهمية ولهذا السبب فكرنا في إنشاء يسدي.</p><p>يسدي منصة التعليم الإلكتروني التي تعمل على ربط تجربة التعلم الأونلاين مع تجربة الأوفلاين. تستهدف المنصة الطلاب من جميع الأعمار والمدربين في مختلف المجالات. الهدف الرئيسي وراء هذه الدورات هو عدم إعطاء الطلاب المعرفة التقنية فقط، ولكن المهارات اللازمة لأداء مهامهم بسلاسة وتحقيق النمو الشخصي.</p><p>تهدف المنصة إلى تغيير معايير التعلم المعروفة في المجتمعات وزيادة التعلم والتطوير المستمر. من خلال عملية اختيار دقيقة للدورات التي من شأنها أن تخلق مسارًا تعليمياً واضحًا ومنطقيًا للطلاب وتخرج جيلًا متعلمًا وواعيًا. تجمع الدورة التدريبية بين أنواع مختلفة من المواد بدءًا من مقاطع الفيديو وصولًا إلى التسجيلات الصوتية ومنشورات المدونة والصور. </p><p>تم تصميم المنصة لتوفير تجربة تعلم تفاعلية، عن طريق الاستفادة من أحدث أساليب التعلم حيث نساعد الطلاب على حفظ المعلومات وفهمها بشكل أفضل. وبما أن بعض المهارات تتطلب التعلم عبر الإنترنت وكذلك التدريب عبر ورش العمل الأوفلاين، فإننا نوفر للمدربين مكانًا حتى يمكنهم التفاعل مع طلابهم.</p><p>سوف يتم إطلاق يسدي بحلول آواخر عام 2020، لكن يمكنك رؤية الهوية كاملة وكذلك تصميم واجهة المستخدم وتجربة المستخدم.</p>",
    "cta":"تصميم العلامة التجارية",
    "cta2":"تصميم تجربة المستخدم / وواجهة المستخدم"
  }
}
</i18n>
